import * as Yup from 'yup'
import translations from '../../../../../translations/en.json'

export const EventDescriptionDefinition = {
  summary: Yup.string()
    .required((translations as any)['error.event_summary_required'])
    .max(140, (translations as any)['error.event_summary_maxlength']),
  description: Yup.string().notRequired().nullable(),
  picture_file_id: Yup.string().notRequired().nullable(),
}
export const EventDescriptionSchema = Yup.object().shape(EventDescriptionDefinition)
